"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.challenge = void 0;
const ChallengeMultiEntryType_1 = require("../../enums/game/ChallengeMultiEntryType");
const RewardType_1 = require("../../enums/game/RewardType");
const challenge_in_game_distribution_1 = require("./challenge-in-game-distribution");
exports.challenge = {
    isEnable: false,
    target: 1,
    challengeText: 'Reach 1 point to get your Reward',
    challengeTextStyle: {
        top: '15%',
        color: '000000',
        backgroundColor: 'ffffff',
        fontSize: '20px',
        position: 'absolute',
    },
    challengeCompletedText: 'Congratulations! You reached 1 point and have won a Reward. Click here to view your Reward',
    challengeCompletedTextStyle: {
        top: '15%',
        color: '000000',
        backgroundColor: 'ffffff',
        fontSize: '20px',
        position: 'absolute',
    },
    rewardType: RewardType_1.RewardType.COUPON_CODE_GENERAL,
    isInGame: false,
    isEmailDistribution: false,
    rewardValue: 'REWARD',
    rewardValueUrl: 'https://www.flarie.com',
    inGameDistribution: challenge_in_game_distribution_1.challengeInGameDistribution,
    isMultiEntryEnable: false,
    multiEntryLimit: 0,
    multiEntryText: 'Number of entries: {entries}',
    multiEntryType: ChallengeMultiEntryType_1.ChallengeMultiEntryType.TOTAL,
    multiEntryStyle: {
        color: 'ffffff',
        font: 'bebas',
        fontSize: '16px',
        position: 'absolute',
        backgroundColor: '000000',
        top: '10%',
    },
};
